<template>
  <div class="accountMar">
  <el-card class="box-card">
    <div slot="header" class="clearfix">
      <span style="float: left;">
        <span style="line-height: 36px;">可用余额：</span>
        <span style="line-height: 36px;color:#4db3ff;">{{(avaliableMoney/100).toFixed(2)}}</span>
      </span>
      <el-button style="float: right;" type="success" @click="withdraw">提现</el-button>
      <span style="line-height: 36px;">提现记录</span>
    </div>
    <div>
      <el-table
      v-loading="table_loading"
      element-loading-text="拼命加载中"
      :data="tableData"
      stripe
      border
      fit
      style="width: 100%">
      <el-table-column
        prop="account"
        header-align="center"
        min-width="180"        
        label="账号">
      </el-table-column>
      <el-table-column
        prop="name"
        header-align="center"
        min-width="130"        
        label="名称">
      </el-table-column>
      <el-table-column
        prop="bankType"
        header-align="center"
        min-width="100"
        label="银行类型">
      </el-table-column>
      <el-table-column
        prop="bankName"
        header-align="center"
        min-width="120"
        label="银行账户名">
      </el-table-column>
      <el-table-column
        prop="bankNum"
        header-align="center"
        min-width="200"
        label="银行卡号">
      </el-table-column>
      <el-table-column
        prop="money"
        header-align="center"
        min-width="160"
        label="金额">
      </el-table-column>
      <el-table-column
        prop="createTime"
        header-align="center"
        min-width="160"
        label="创建时间">
      </el-table-column>
      <el-table-column
        prop="status"
        header-align="center"
        min-width="95"
        label="状态">
        <template scope="scope">
        <el-tag :type="scope.row.status === '已提现' ? 'success' : (scope.row.status === '申请中' ? 'warning' : 'danger')"
        close-transition>{{scope.row.status}}</el-tag>
        </template>
      </el-table-column>
    </el-table>
    </div>
    <div class="table_pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNo"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageTotal">
      </el-pagination>
    </div>
  </el-card>
  </div>
</template>

 <script>
    import $axios from '../../https/config'
    // import {isNull} from '../../js/tool'

    export default {
      data () {
        return {
          tableData: [],
          pageTotal: 0,
          pageSize: 10,
          pageNo: 1,
          userType: this.$store.state.userType,
          table_loading: false,
          addAccountShow: false,
          updatePwdShow: false,
          userNum: '',
          searchValue: '',
          searchSelect: '-1',
          avaliableMoney: 0
        }
      },
      created: function () {
        this.pageNo = 1
        this.queryRecordList()
      },
      methods: {
        queryRecordList () {
          var _this = this
          var params = {
            pageNo: _this.pageNo,
            pageSize: _this.pageSize
          }
          this.table_loading = true
          this.tableData = []
          $axios.get('/withdraw/listSelf', params, 'headers', function (res) {
            if (res && res.resultStatus === true) {
              var resData = []
              if (res.resultData) {
                _this.pageTotal = res.resultData.count
                _this.avaliableMoney = res.resultData.money
                if (res.resultData.list) {
                  for (var i = 0; i < res.resultData.list.length; i++) {
                    var itemData = res.resultData.list[i]
                    var item = {
                      account: itemData.username,
                      money: (itemData.amount / 100).toFixed(2),
                      bankName: itemData.bank_account_name,
                      bankType: itemData.bank_name,
                      bankNum: itemData.bank_card,
                      name: itemData.nickname,
                      status: itemData.status === 0 ? '申请中' : itemData.status === 1 ? '已提现' : '拒绝',
                      createTime: new Date(itemData.create_time).getFullYear() + '-' + (new Date(itemData.create_time).getMonth() + 1) + '-' + new Date(itemData.create_time).getDate()
                    }
                    resData.push(item)
                  }
                }
                _this.tableData = resData
              }
            } else {
            }
            _this.table_loading = false
          }, function () {})
        },
        handleSizeChange (val) {
          this.pageSize = val
          if (this.searchSelect === '-1') {
            this.queryAccountList()
          } else {
            this.queryAccountByKeyword(this.searchSelect, this.searchValue, this.pageNo, this.pageSize)
          }
        },
        handleCurrentChange (val) {
          this.pageNo = val
          if (this.searchSelect === '-1') {
            this.queryAccountList()
          } else {
            this.queryAccountByKeyword(this.searchSelect, this.searchValue, this.pageNo, this.pageSize)
          }
        },
        withdraw () {
          this.$router.push({path: '/financeMgr/withdraw', query: {money: this.avaliableMoney}})
        }
      },
      components: {
      }
    }
  </script>

  <style lang="scss">
    .table_pagination {
      text-align: right;
      margin-top: 10px; 
    }
    .accountMar {
      .el-select .el-input {
        width: 110px;
      }
    }
  </style>
  


// WEBPACK FOOTER //
// src/page/financeMgr/withdrawRecord.vue